// import React, { Suspense, lazy } from 'react'
import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import AuthWrapper from './wrappers/auth'

// Pages
// const Auth = lazy(() => import('../pages/Auth'))
import Auth from '../pages/Auth'

class AuthRoutes extends React.Component {
    _isMounted = false

    state = {
        needRedirect: false,
        from: {},
        to: {},
    }

    componentDidMount() {
        this._isMounted = true

        const { location } = this.props

        if (location.state) {
            if (location.state.to) {
                this.setState({
                    needRedirect: true,
                    to: location.state.to,
                    from: location.state.from,
                })
                return
            }
            if (location.state.from) {
                this.setState({
                    needRedirect: true,
                    to: location.state.from,
                    from: location.state.from,
                })
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    render() {
        const { needRedirect, from, to } = this.state
        const { is_auth } = this.props

        return is_auth ? (
            needRedirect ? (
                <Redirect to={to} />
            ) : (
                // Redirect after login
                <Redirect to={{ pathname: '/account/my-projects', state: { from } }} />
            )
        ) : (
            // <Suspense fallback={<></>}>
            <AuthWrapper path="/auth" component={Auth} />
            // </Suspense>
        )
    }
}

const mapStateToProps = state => {
    return {
        is_auth: state.is_auth,
    }
}

export default connect(mapStateToProps, null)(AuthRoutes)
